import { convertNumberPersianToEnglish } from '@helper/functions';

export default function Step1({ formikSignUpRealestate, handleSubmitAttempt }) {
  const handleChangeNumber = (e) => {
    const { name, value } = e.target;
    const englishValue = convertNumberPersianToEnglish(value);
    formikSignUpRealestate.setFieldValue(name, englishValue);
  };
  return (
    <form
      onSubmit={handleSubmitAttempt}
      className="grid grid-cols-2 gap-x-4 gap-y-8 lg:gap-x-6 lg:gap-y-12 w-full max-w-[550px] place-items-start"
    >
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1 w-full">
        <label className="text-sm lg:text-base" htmlFor="">
          نام مدیر آژانس
        </label>
        <input
          name="firstName"
          onChange={formikSignUpRealestate.handleChange}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.firstName}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.firstName && formikSignUpRealestate.touched.firstName
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="مثال : امیر رضا"
          type="text"
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.firstName && formikSignUpRealestate.touched.firstName
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.firstName}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 lg:col-span-1 w-full">
        <label className="text-sm lg:text-base" htmlFor="">
          نام خانوادگی مدیر آژانس
        </label>
        <input
          name="lastName"
          onChange={formikSignUpRealestate.handleChange}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.lastName}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.lastName && formikSignUpRealestate.touched.lastName
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="مثال : خسروی"
          type="text"
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.lastName && formikSignUpRealestate.touched.lastName
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.lastName}
        </span>
      </div>
      <div className="flex flex-col relative gap-1 col-span-2 w-full">
        <label className="text-sm lg:text-base" htmlFor="">
          کد ملی مدیر آژانس
        </label>
        <input
          name="nationalID"
          onChange={handleChangeNumber}
          onBlur={formikSignUpRealestate.handleBlur}
          value={formikSignUpRealestate.values.nationalID}
          dir="rtl"
          className={`w-full rounded-lg border-[1.5px] ${
            formikSignUpRealestate.errors.nationalID && formikSignUpRealestate.touched.nationalID
              ? 'border-error'
              : 'border-blackFont-200 focus:border-blackFont-900'
          } py-2 px-4 flex items-center justify-between overflow-hidden transition-all placeholder:font-light`}
          placeholder="باید 10 رقم باشد"
          type="text"
        />
        <span
          className={`text-[12px] text-error absolute -bottom-[22px] transition-all ${
            formikSignUpRealestate.errors.nationalID && formikSignUpRealestate.touched.nationalID
              ? 'visible opacity-100'
              : 'invisible opacity-0'
          }`}
        >
          {formikSignUpRealestate.errors.nationalID}
        </span>
      </div>
      <div className="sm:col-span-1 col-span-2 max-sm:w-full">
        <button type="submit" className="btn btn-primary max-sm:w-full">
          تایید و ادامه
        </button>
      </div>
    </form>
  );
}
